import { useContext, useMemo, useState } from "react";
import { useQuery } from "react-query";
import RoyaltiesPresenter from "../royalties/RoyaltiesPresenter";
import { TipsEditDialog } from "./tips-edit-dialog/TipsEditDialog";
import useEventListeners from "@arelia-hooks/useEventListeners";
import { DONATION_UPDATE_EVENT_NAME } from "../../features/earnings/constants";
import { RevenueOverview } from "@arelia-types/earnings";
import { http } from "src/api/http";
import EditAciton from "@arelia-components/ui-atoms/EditAciton";
import { EarningsPeriod, EarningsPeriodDisplay, PeriodDisplay } from "../../utils/constants/constants";
import WidgetMenuSelector from "../../components/ui-atoms/WidgetMenuSelector";
import getMenuItems from "@arelia-utils/helpers/getMenuItems";
import AppContext from "src/AppContext";
import UnavailableContent from "@arelia-components/ui-atoms/UnavailableContent";
import { Card, CardContent, CardHeader } from "@mui/material";
import { SubscriptionPlanName } from "@arelia-types/subscriptions";

export default function TipsContainer() {
  const [dialogOpened, setDialogOpened] = useState(false);
  const [selectedPeriod, setSelectedPeriod] = useState(EarningsPeriod.Year);
  const [selectedPeriodDisplay, setSelectedPerionDisplay] = useState<PeriodDisplay>(EarningsPeriodDisplay.Year);
  const { account } = useContext(AppContext);

  const defaultResponse: RevenueOverview = {
    total: 0,
    topLevelTotal: 0,
    totalPrevPeriod: 0,
    totalThisPeriod: 0,
    data: [],
    totalRecordCount: 0,
    updatedAt: (new Date()).toISOString()
  }

  const { data: recordsResponse = defaultResponse, isLoading: loadingRecords, isError: errorRecords, refetch: refreshRecords } = useQuery<RevenueOverview>({
    queryFn: () => http(`/api/earnings/tips?skip=0&take=99&period=${selectedPeriod}`),
    queryKey: ['tipsTotal', selectedPeriod]
  });

  const recordsData: RevenueOverview = useMemo(() => recordsResponse as RevenueOverview, [recordsResponse]);

  const handleDialogClose = () => {
    setDialogOpened(false);
  };

  const handleTotalsRefresh = () => {
    refreshRecords();

    const event = new CustomEvent(DONATION_UPDATE_EVENT_NAME);
    window.dispatchEvent(event);
  };

  useEventListeners([DONATION_UPDATE_EVENT_NAME], () => {
    handleTotalsRefresh();
  });

  const menuItems = getMenuItems(EarningsPeriodDisplay);

  const setPeriod = (period: EarningsPeriod) => {
    setSelectedPeriod(period);
    setSelectedPerionDisplay(EarningsPeriodDisplay[period]);
  }

  const renderPeriodSelector = () => (
    <WidgetMenuSelector<EarningsPeriod>
      onClick={setPeriod}
      selectedValue={selectedPeriod}
      labelText={selectedPeriodDisplay.menuLabelDisplay}
      menuItems={menuItems}
    />
  );

  return (
    account?.plan === SubscriptionPlanName.Starter
    ?
      <Card sx={{ height: "100%" }}>
        <CardHeader title="Donations & Tips"/>
        <CardContent>
          <UnavailableContent message="To add/edit Donations & Tips upgrade to Premium" />
        </CardContent>
      </Card>
    : <>
      <RoyaltiesPresenter
        data={recordsData}
        loading={loadingRecords}
        error={errorRecords}
        extraActions={<EditAciton editClicked={() => setDialogOpened(true)} />}
        widgetId="TIPS"
        title="Donations & Tips"
        headerComponent={renderPeriodSelector()}
        selectedPeriod={selectedPeriodDisplay.timespanDisplay}
      />
      <TipsEditDialog
        open={dialogOpened}
        data={recordsData}
        title={'Donations & Tips'}
        onClose={handleDialogClose}
        headerComponent={renderPeriodSelector()}
        onTotalsRefresh={handleTotalsRefresh}
        selectedPeriod={selectedPeriodDisplay.timespanDisplay}
      />
    </>
  );
}
